import { useQuery } from '@apollo/client'
import { GET_PATIENT_RED_FLAGS } from 'domains/carrotGraph/queries'

/**
 * Get a Patient by id.
 * @param {Object} options - Configuration options for the hook.
 * @param {string} options.patientId - A string corresponding to the patient's id
 * @param {boolean} options.skip - Flag indicating whether to skip the query or not.
 * @return {{loading, error, patient}} loading is the loading state of the request returned by useQuery. error is the error state of the request, if any, returned by useQuery. patient is an object with the following properties: codeName, deviceList, id, identifiableInfo, userInfo, and medicationScheduleList.
 */
const usePatientRedFlags = ({
  patientId,
  skip = false,
  startTime,
  endTime,
}) => {
  const { loading, error, data } = useQuery(GET_PATIENT_RED_FLAGS, {
    variables: { patientId, startTime, endTime },
    fetchPolicy: 'cache-and-network',
    skip,
  })

  const patientRedFlags = data?.patient

  return { loading, error, patientRedFlags }
}

export default usePatientRedFlags
